import { IAccount } from '@account-users';
import {
  DeliveryStatisticsActions,
  DeliveryStatisticsActionTypes,
} from '../actions/delivery-statistics.actions';
import { Statistics, DateRange, makeStatistics } from '../models';
import { EmailActionTypes, EmailActions } from '../actions/email.actions';
import { SmsActionTypes, SmsActions } from '../actions/sms.actions';

export interface State {
  accounts: IAccount[];
  statistics: Statistics;
  statisticsOverTime: Statistics[];
  domains: Statistics[];
  sendings: Statistics[];
  countryCodes: Statistics[];
  loading: boolean;
  dateRange: DateRange;
  accountId: string;
}

export const initialState: State = {
  accounts: [],
  statistics: makeStatistics(),
  statisticsOverTime: [],
  domains: [],
  sendings: [],
  countryCodes: [],
  loading: false,
  dateRange: { from: 0, to: 0 },
  accountId: '',
};

export function reducer(
  state = initialState,
  action: DeliveryStatisticsActions | EmailActions | SmsActions,
): State {
  switch (action.type) {
    case DeliveryStatisticsActionTypes.Clear: {
      return {
        ...initialState,
        accounts: state.accounts,
      };
    }

    case DeliveryStatisticsActionTypes.GetAccountsSuccess: {
      return {
        ...state,
        accounts: action.payload,
      };
    }

    case SmsActionTypes.GetStatisticsOverview:
    case EmailActionTypes.GetStatistics: {
      return {
        ...state,
        ...action.payload,
        loading: true,
      };
    }

    case SmsActionTypes.GetStatisticsOverviewSuccess:
    case EmailActionTypes.GetStatisticsSuccess: {
      return {
        ...state,
        statistics: action.payload,
        loading: false,
      };
    }

    case SmsActionTypes.GetTotalTimelineSuccess:
    case EmailActionTypes.GetStatisticsOverTimeSuccess: {
      return {
        ...state,
        statisticsOverTime: action.payload,
      };
    }

    case EmailActionTypes.GetDomainStatisticsSuccess: {
      return {
        ...state,
        domains: action.payload,
      };
    }

    case EmailActionTypes.GetSendingsStatisticsSuccess: {
      return {
        ...state,
        sendings: action.payload,
      };
    }

    case SmsActionTypes.GetCountryCodesSuccess: {
      return {
        ...state,
        countryCodes: action.payload,
      };
    }

    default:
      return state;
  }
}
